var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/**
 *
 * @class
 */
export default class EmbedBlock {
    /**
     * @constructor
     * @param {HTMLElement} element The navigation bar root element
     */
    constructor(element) {
        this.components = {
            embedBlock: element,
            embed: element.querySelector('[data-component="Embed"]')
        };
        const replaceCoverWithYoutubeEmbed = (embedCode, embedTitle) => {
            if (this.components.embed) {
                if (!embedCode.includes("title")) {
                    const embedCodeWithTitle = embedCode.replace("<iframe", `<iframe title="${embedTitle}"`);
                    this.components.embed.innerHTML = embedCodeWithTitle;
                }
                else {
                    this.components.embed.innerHTML = embedCode;
                }
            }
        };
        // Get OptanonActiveGroups from window
        const getOptanonActiveGroups = () => __awaiter(this, void 0, void 0, function* () {
            while (!window.hasOwnProperty('OptanonActiveGroups'))
                yield new Promise(resolve => setTimeout(resolve, 1000));
            // @ts-ignore
            return window.OptanonActiveGroups;
        });
        // Get OneTrust from window
        const getOneTrust = () => __awaiter(this, void 0, void 0, function* () {
            while (!window.hasOwnProperty('OneTrust'))
                yield new Promise(resolve => setTimeout(resolve, 1000));
            // @ts-ignore
            return window.OneTrust;
        });
        const maybeReplaceCoverWithYoutubeEmbed = (embedCode, embedTitle) => __awaiter(this, void 0, void 0, function* () {
            //check if functional cookies have been accepted. if yes, then replace cover with youtube embed
            const optanonActiveGroups = yield getOptanonActiveGroups();
            const oneTrust = yield getOneTrust();
            const oneTrustFunctionalCookieCode = 'C0003';
            if (optanonActiveGroups && oneTrust) {
                if (optanonActiveGroups.includes(oneTrustFunctionalCookieCode)) {
                    replaceCoverWithYoutubeEmbed(embedCode, embedTitle);
                }
                oneTrust.OnConsentChanged(() => __awaiter(this, void 0, void 0, function* () {
                    window.location.href = window.location.href;
                }));
            }
        });
        if (this.components.embed != null && this.components.embed.dataset.embedCode != undefined) {
            const embedcode = this.components.embed.dataset.embedCode;
            const embedTitle = this.components.embed.dataset.embedTitle;
            const embedIsFromYoutube = embedcode.includes("https://www.youtube.com");
            if (embedIsFromYoutube) {
                maybeReplaceCoverWithYoutubeEmbed(embedcode, embedTitle);
            }
            else {
                this.components.embed.innerHTML = embedcode;
            }
        }
    }
    /**
     * Creates new instances of IEmbedBlockUtils for each `[data-component="EmbedBlock"]` element,
     * and if it's a youtube embed, swaps out the domain in the embed code for the youtube no-cookie domain
     */
    static init() {
        const embedBlocks = [...document.querySelectorAll('[data-component="EmbedBlock"]')];
        embedBlocks.forEach(embedBlock => {
            const embedBlockUtil = new EmbedBlock(embedBlock);
        });
    }
}
